import {
  getSECURE_API,
  API,
  baseURL,
  TOKEN_KEY,
  sendFormDataRequest
} from 'api';
import axios from 'axios';

const SECURE_API = getSECURE_API();
SECURE_API.interceptors.request.use(req => {
  req.baseURL = `${req.baseURL}/withdraw-requests`;
  return req;
});

// API.interceptors.request.use((req) => {
//   req.baseURL = `${req.baseURL}/games`;
//   return req;
// });

export const getAll = () => SECURE_API.get('/');
export const getMe = () => SECURE_API.get('/me');

export const createRequest = data => SECURE_API.post('/', data);

export const updateRequestApi = ({ id, body }) =>
  SECURE_API.put(`/${id}`, {
    ...body
  });
export const deleteOne = id => SECURE_API.delete(`/${id}`);
